import { render, staticRenderFns } from "./orderManagement.vue?vue&type=template&id=0b132918&scoped=true&"
import script from "./orderManagement.vue?vue&type=script&lang=js&"
export * from "./orderManagement.vue?vue&type=script&lang=js&"
import style0 from "./orderManagement.vue?vue&type=style&index=0&id=0b132918&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b132918",
  null
  
)

export default component.exports